// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"de50740d","558":"e73a0924"}[chunkId] + ".chunk.js";
};